import { fetchApi } from '@/lib/api';
import type { InboxKindDelivery, InboxMarksInput, InboxResponse, InboxSettingsResponse } from '@shared/types/inbox';

/** T-37: the signed-in person's Inbox across every project (worker/src/api/inbox.ts). */

const base = '/inbox';

function json(method: string, body?: unknown): RequestInit {
  return { method, body: body === undefined ? undefined : JSON.stringify(body) };
}

/** The loaders' shared key prefix: the sidebar's count and the page share one answer. */
export const INBOX_LOADER_KEY = 'inbox:items';

export function getInbox(opts: { signal?: AbortSignal } = {}) {
  return fetchApi<InboxResponse>(base, { signal: opts.signal });
}

export function setInboxMarks(input: InboxMarksInput) {
  return fetchApi<{ ok: true }>(`${base}/marks`, json('POST', input));
}

export function getInboxSettings(opts: { signal?: AbortSignal } = {}) {
  return fetchApi<InboxSettingsResponse>(`${base}/settings`, { signal: opts.signal });
}

export function saveInboxSettings(kinds: Array<Pick<InboxKindDelivery, 'kind' | 'push'> & { slack?: boolean }>) {
  return fetchApi<InboxSettingsResponse>(`${base}/settings`, json('PUT', { kinds }));
}

/** This browser's push subscription (PushSubscription.toJSON()). */
export function savePushSubscription(subscription: PushSubscriptionJSON) {
  return fetchApi<InboxSettingsResponse>(`${base}/push/subscriptions`, json('POST', subscription));
}

export function deletePushSubscription(endpoint: string | null) {
  return fetchApi<InboxSettingsResponse>(`${base}/push/subscriptions`, json('DELETE', { endpoint }));
}

export function sendTestPush() {
  return fetchApi<{ sent: number; browsers: number }>(`${base}/push/test`, json('POST'));
}
